import { SidenavItemInterface } from 'src/app/layout/side-nav/interfaces/side-nav-items.interface';

export const cmSidenavConfig: SidenavItemInterface[] = [
  {
    id: 'vehicles',
    label: 'vehicles',
    routerLink: '/vehicles',
    permissions: ['VIEW_VEHICLE'],
  },
  {
    id: 'maintenance',
    label: 'maintenance',
    routerLink: '/maintenance',
    permissions: ['VIEW_MAINTENANCE'],
  },
  {
    id: 'fine',
    label: 'fine',
    routerLink: '/fine',
    permissions: ['VIEW_FINE'],
  },
  {
    id: 'vehicleFiles',
    label: 'vehicleFiles',
    routerLink: '/vehicle-files',
    permissions: ['VIEW_VEHICLE_FILE'],
  },
  {
    id: 'reminder',
    label: 'reminder',
    routerLink: '/reminder',
    permissions: ['VIEW_REMINDER'],
  },
];


export const typesSettingsSidenavConfig: SidenavItemInterface[] = [ 
 {
  id: 'types',
  label: 'types',
  isActive: false,
  expanded: false,
  items: [
    {
      id: 'features',
      label: 'features',
      routerLink: '/features',
      permissions: ['VIEW_FEATURE'],
    },
    {
      id: 'maintenanceType',
      label: 'maintenanceType', 
      routerLink: '/maintenance-type',
    },
    {
      id: 'files',
      label: 'files',
      routerLink: '/files',
      permissions: ['VIEW_FILE_TYPE'],
    },
    {
      id: 'reminderTypes',
      label: 'reminderTypes',
      routerLink: '/reminderTypes',
      permissions: ['VIEW_REMINDER_TYPE'],
    },
  ]
 }
]